import React, { Component } from "react";
import { Segment, Header, Button } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getSyncedHotels } from "../hotels/selectors";
import { isDemo, isAdmin } from "../users/selectors";
import { translate } from "react-i18next";
class Preview extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h3">
          {this.props.username == undefined || this.props.username === ""
            ? this.props.t("synchronization:noSynchronizingText")
            : this.props.t("synchronization:synchronizingText", {
                account: this.props.username
              })}
        </Header>
        {this.props.hotels.length > 0 && (
          <Header as="h4">{`${this.props.t(
            "synchronization:hotelsText"
          )}:`}</Header>
        )}
        <ul>
          {this.props.hotels.map(hotel => (
            <li>{hotel.hotelName}</li>
          ))}
        </ul>
        {this.props.isAdmin && (
          <Button
            color="orange"
            onClick={() => this.props.history.push("/hotel/synchronize")}
            disabled={this.props.isDemo}>
            {this.props.t("synchronization:synchronizeButton")}
          </Button>
        )}
      </Segment>
    );
  }
}
export default withRouter(
  connect(state => ({
    hotels: getSyncedHotels(state),
    username: state.synchronization.username,
    isDemo: isDemo(state),
    isAdmin: isAdmin(state)
  }))(translate("translations")(Preview))
);



// WEBPACK FOOTER //
// ./src/synchronization/Preview.js